<template>
    <div class="w-full">
      <div class="w-full md:w-1/2 mx-auto">
        <div class="w-full mt-10">
          <h1 class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5" >
              Status Antrian
          </h1>
       </div>
       <div class="w-full text-center">
            <p class="font-bold text-sm">Kode Booking</p>
            <p class="text-teal-500 font-bold">{{statusAntrian.bookAntrian.kdBooking}}</p>
            <p class="font-bold text-sm mt-2">Antrean Poliklinik</p>
            <p class="text-teal-500 font-bold"> {{ statusAntrian.poli }}</p>
            <p class="font-bold text-sm mt-2">Tanggal Periksa</p>
            <p class="text-teal-500 font-bold"> {{ statusAntrian.tanggalPeriksa }}</p>
       </div>
        <div v-if="statusAntrian" class="w-full flex flex-col justify-center items-center">
          <StatusAntrianCard
            :statusAntrian = "statusAntrian"
          />
        </div>
        <div v-else class="w-full mt-2">
            <div class="w-full h-20 flex items-center bg-red-600 p-2 rounded-lg text-white justify-center">
                    STATUS ANTRIAN TIDAK DITEMUKAN
              </div>
        </div>
    </div>
    </div>
</template>


<script>
import { Link } from '@inertiajs/inertia-vue3'
import LayoutNoHeader from '../Shared/LayoutNoHeader.vue'
import RandomShape from '../Shared/RandomShape.vue';
import StatusAntrianCard from '../Shared/StatusAntrianCard.vue';
export default{
components: {
    Link,
    RandomShape,
    StatusAntrianCard,
    StatusAntrianCard
},
props: {
  statusAntrian: Object
},
layout: LayoutNoHeader
}
</script>